import React, { useEffect, useRef, useState } from "react";
import Pagination from "react-js-pagination";
import NotFound from "../../components/not-found/NotFound";
import ViewListRoundedIcon from "@mui/icons-material/ViewListRounded";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import IconButton from "../../components/Button/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import BlockIcon from "@mui/icons-material/Block";
import Switch from "../../components/Switch/Switch";
import { SecondaryButton } from "../../components/Button/Button";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import { DatePicker, Select } from "../../components/Form";
import { toast } from "sonner";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import useDebounce from "../../hooks/useDebounce";
// import { getOrderApi } from '../../services/orderManagement'
// import { SiMicrosoftexcel } from "react-icons/si";
import { IoSearch } from "react-icons/io5";
import profileImage from "../../Assests/image/profile_not_found.png";
import { user } from "../../routes/route";
import scrollToUp from "../../utils/scrollToUp";
import { toastMessage } from "../../utils/toastMessage";
import {
  fetchConsultantListApi,
  getDeletedConsultantListApi,
  logoutConsultantFromAllDevice,
  moveConsultantToBinApi,
  restoreConsultantFromBinApi,
  fetchAllTagsApi,
  createTagApi,
  setConsultantTagsApi,
  updateTagApi,
  deleteTagApi,
  setConsultantGroupApi,
  setConsultantSubGroupApi,
} from "../../services/consultantManagement";
import findSerialNumber from "../../utils/findSerialNumber";
import { dateFormat, dateFormatUtc } from "../../utils/dateFormat";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ApprovedConsultant from "./ApprovedConsultant";
import ConsultantStatus, { FakeStatusModal } from "./ConsultantStatus";
import { flag, gender } from "../../utils/genderList";
import common from "../../routes/common";
import AddConsultant from "./AddConsultant";
import { fatchCategoryApi } from "../../services/categoryManagement";
import { charLimit } from "../../utils/charLimit";
import { CapitalizeFirstWord } from "../../utils/CapitalizeFirstWord";
import { getLocalStorage, setLocalStorage } from "../../config/config";
import useDownloadWithPassword from "../../hooks/useDownloadWithPassword";
import Loader from "../../comman/Loader";
import csv from "../../Assests/image/csv.svg";
import { consultant } from "../../routes/route";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import useButtonLoader from "../../hooks/UseButtonLoader";
import ModalBox from "../../components/modal/ModalBox";
import { FormControl, InputLabel, Select as MuiSelect, MenuItem, TextField, Typography, Chip, Popover, Box, Button, IconButton as MuiIconButton, Menu, ListItemIcon, ListItemText } from "@mui/material";
import { CustomTabs, CustomTab } from "../../components/tabs/Tabs";
import { GROUP_COLORS, SUB_GROUP_COLORS, SUB_GROUP_OPTIONS } from "../../utils/constants";

const { USER_DETAIL } = user;
const { NOT_FOUND } = common;
const { CONSULTANT_ADD, CONSULTANT_EDIT, CONSULTANT_DELETE } = consultant;

const ConsultantList = () => {
  // Tab state: 0 = Consultant Management, 1 = Consultant Activity (default open)
  const [activeTab, setActiveTab] = useState(1);
  // Consultant Activity sub-type: "all" | "deactive" | "delete" (only used when activeTab === 1)
  const [activityListType, setActivityListType] = useState("all");

  const [searchParam, setSearchParam] = useSearchParams();
  let activePage = +searchParam.get("page") || 1;
  let pageLimit = +searchParam.get("limit") || 10;
  let registrationDate = searchParam.get("registrationDate") || "";
  let problemValue = searchParam.get("problem") || "";
  let skillsValue = searchParam.get("skills") || "";
  let flagValue =  searchParam.get("missed") || "" ;
  let genderValue = searchParam.get("gender") || "";
  let tagValue = searchParam.get("tag") || "";
  let groupValue = searchParam.get("group") || "";
  let subGroupValue = searchParam.get("subGroup") || "";
  const [search, setSearch] = useState(
    getLocalStorage("consultantList", "search") || ""
  );
  const debounceValue = useDebounce(search || "", 300);
  const prevDebounceValue = useRef(debounceValue);
  const isNew = searchParam.get("isNew") === "true";
  const requestView = searchParam.get("requestView") || "request";
  const isRecycleBinView = isNew && requestView === "bin";
  const [total, setTotal] = useState(0);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [consultantList, setConsultantList] = useState([]);
  const [skillList, setSkillList] = useState([]);
  const [buttonref, buttonLoader] = useButtonLoader("Logout");
  const [statusModal, setStatusModal] = useState(false);
  const [statusValue, setStatusValue] = useState("");
  const [statusId, setStatusId] = useState("");
  const [logoutCosultantModel, setLogoutCosultantModel] = useState(false);
  const [statusSearch, setStatusSearch] = useState("");
  const [startDateSearch, setStartDateSearch] = useState("");
  const [endDateSearch, setEndDateSearch] = useState("");
  const [approveConsultant, setApproveConsultant] = useState(false);
  const [moveToBinModal, setMoveToBinModal] = useState(false);
  const [restoreFromBinModal, setRestoreFromBinModal] = useState(false);
  const [addConsultantModel, setAddConsultantModel] = useState(false);
  const [consultantSkillOption, setConsultantSkillOption] = useState([]);
  const [consultantRequstCount, setConsultantRequestCount] = useState("");
  const [approveStatus, setApproveStatus] = useState("");
  const [moveToBinLoading, setMoveToBinLoading] = useState(false);
  const [restoreFromBinLoading, setRestoreFromBinLoading] = useState(false);
  const navigate = useNavigate();
  
  // Tag states
  const [allTags, setAllTags] = useState([]);
  const [consultantTags, setConsultantTags] = useState({}); // { consultantId: [tags] }
  const [tagLoading, setTagLoading] = useState({}); // { consultantId: true/false }
  const [createTagAnchorEl, setCreateTagAnchorEl] = useState({}); // { consultantId: element }
  const [newTagName, setNewTagName] = useState("");
  const [selectedTagValue, setSelectedTagValue] = useState({}); // { consultantId: "" }
  const [tagsFilterAnchorEl, setTagsFilterAnchorEl] = useState(null); // For Tags filter dropdown menu
  const [consultantGroups, setConsultantGroups] = useState({}); // { consultantId: groupString }
  const [consultantSubGroups, setConsultantSubGroups] = useState({}); // { consultantId: subGroupString }

  const [fakeState, setFakeState] = useState(null)

  // Time range filter states
  const [timeRange, setTimeRange] = useState(searchParam.get("timeRange") || "");
  const [timeRangeStartDate, setTimeRangeStartDate] = useState(searchParam.get("timeRangeStartDate") || "");
  const [timeRangeEndDate, setTimeRangeEndDate] = useState(searchParam.get("timeRangeEndDate") || "");
  const [approvalTimeRange, setApprovalTimeRange] = useState(searchParam.get("approvalTimeRange") || "");
  const [approvalTimeRangeStartDate, setApprovalTimeRangeStartDate] = useState(searchParam.get("approvalTimeRangeStartDate") || "");
  const [approvalTimeRangeEndDate, setApprovalTimeRangeEndDate] = useState(searchParam.get("approvalTimeRangeEndDate") || "");
  const [binRemark, setBinRemark] = useState("");
  const [binRemarkError, setBinRemarkError] = useState("");
  
  // Time range options
  const timeRangeOptions = [
    { value: "today", label: "Today" },
    { value: "yesterday", label: "Yesterday" },
    { value: "last7days", label: "Last 7 Days" },
    { value: "last30days", label: "Last 30 Days" },
    { value: "thisMonth", label: "This Month" },
    { value: "lastMonth", label: "Last Month" },
    { value: "custom", label: "Custom Range" }
  ];

  // handle all hooks

  const { loading, requestDownload, DownloadPasswordModal } = useDownloadWithPassword();

  useEffect(() => {
    setLocalStorage("consultantList", "search", search);
  }, [search]);

  //*********Handel status********* */
  const statusUpdateHandler = (id, status) => {
    setStatusModal(true);
    setStatusId(id);
    setStatusValue(status);
  };

  const fakeUpdateHandler = (id, status) => {
    setFakeState({ id, status });
  };

  const logoutCloseModel = () => {
    setLogoutCosultantModel(false);
    setStatusId("");
  };

  const handleExcelDownload = () => {
    try {
      const url = `${URL}/admin/consultant/download`;
      const params = {
        filter: {}
      };
      
      // Add all current filters to the export
      if(search) {
        params.filter.search = search;
      }
      if (genderValue) {
        params.filter.gender = genderValue;
      }
      if (problemValue) {
        params.filter.expertise = problemValue;
      }
      if (registrationDate) {
        params.filter.registerDate = registrationDate;
      }
      if (flagValue) {
        params.filter.missed = flagValue;
      }
      if (timeRange) {
        params.filter.timeRange = timeRange;
      }
      if (timeRangeStartDate) {
        params.filter.timeRangeStartDate = timeRangeStartDate;
      }
      if (timeRangeEndDate) {
        params.filter.timeRangeEndDate = timeRangeEndDate;
      }
      if (approvalTimeRange) {
        params.filter.approvalTimeRange = approvalTimeRange;
      }
      if (approvalTimeRangeStartDate) {
        params.filter.approvalTimeRangeStartDate = approvalTimeRangeStartDate;
      }
      if (approvalTimeRangeEndDate) {
        params.filter.approvalTimeRangeEndDate = approvalTimeRangeEndDate;
      }
      if (tagValue) {
        params.filter.tag = tagValue;
      }
      if (groupValue) {
        params.filter.group = groupValue;
      }
      if (subGroupValue) {
        params.filter.subGroup = subGroupValue;
      }
      if (activeTab === 1 && activityListType === "deactive") {
        params.filter.status = false;
      }
      
      requestDownload(
        "admin/consultant/download",
        `consultant-excel-file-${dateFormat(new Date())}.xlsx`,
        params
      );
    } catch (e) {
      console.log(e.message);
    }
  };

  const handleLogoutHandler = async () => {
    try {
      buttonLoader(true);
      const sendData = { consultantId: statusId };
      const { data } = await logoutConsultantFromAllDevice(sendData);
      if (data.code === 200) {
        logoutCloseModel();
      } else {
        toastMessage(data.message, "error", "consultantList");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      buttonLoader(false);
    }
  };

  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    const next = new URLSearchParams(searchParam);
    if (Number(event) <= 1) {
      next.delete("page");
    } else {
      next.set("page", String(event));
    }
    setSearchParam(next);
  };

  const handlePageLimitChange = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    const next = new URLSearchParams(searchParam);
    next.set("limit", String(newLimit));
    next.delete("page");
    setSearchParam(next);
  };
  //*********Handel refresh icon********* */
  const refreshHandler = (event) => {
    setSearch("");
    setTimeRange("");
    setTimeRangeStartDate("");
    setTimeRangeEndDate("");
    setApprovalTimeRange("");
    setApprovalTimeRangeStartDate("");
    setApprovalTimeRangeEndDate("");
    searchParam.delete("page");
    searchParam.delete("limit");
    searchParam.delete("problem");
    searchParam.delete("gender");
    searchParam.delete("missed");
    searchParam.delete("registrationDate");
    searchParam.delete("isNew");
    searchParam.delete("timeRange");
    searchParam.delete("timeRangeStartDate");
    searchParam.delete("timeRangeEndDate");
    searchParam.delete("approvalTimeRange");
    searchParam.delete("approvalTimeRangeStartDate");
    searchParam.delete("approvalTimeRangeEndDate");
    searchParam.delete("tag");
    searchParam.delete("group");
    searchParam.delete("subGroup");
    setSearchParam(searchParam);
  };

  const applyFilter = () => {
    // Update URL parameters for time range
    if (timeRange) {
      searchParam.set("timeRange", timeRange);
    } else {
      searchParam.delete("timeRange");
    }
    if (timeRangeStartDate) {
      searchParam.set("timeRangeStartDate", timeRangeStartDate);
    } else {
      searchParam.delete("timeRangeStartDate");
    }
    if (timeRangeEndDate) {
      searchParam.set("timeRangeEndDate", timeRangeEndDate);
    } else {
      searchParam.delete("timeRangeEndDate");
    }
    if (approvalTimeRange) {
      searchParam.set("approvalTimeRange", approvalTimeRange);
    } else {
      searchParam.delete("approvalTimeRange");
    }
    if (approvalTimeRangeStartDate) {
      searchParam.set("approvalTimeRangeStartDate", approvalTimeRangeStartDate);
    } else {
      searchParam.delete("approvalTimeRangeStartDate");
    }
    if (approvalTimeRangeEndDate) {
      searchParam.set("approvalTimeRangeEndDate", approvalTimeRangeEndDate);
    } else {
      searchParam.delete("approvalTimeRangeEndDate");
    }
    searchParam.delete("page");
    setSearchParam(searchParam);
    fetchConsultantListHandler(isNew);
  };

  // Time range handler
  const handleTimeRangeChange = (value) => {
    setTimeRange(value);
    if (value !== 'custom') {
      setTimeRangeStartDate("");
      setTimeRangeEndDate("");
    }
  };

  // Time range date change handler
  const handleTimeRangeDateChange = (type, value) => {
    if (type === 'start') {
      setTimeRangeStartDate(value);
    } else {
      setTimeRangeEndDate(value);
    }
  };

  const handleApprovalTimeRangeChange = (value) => {
    setApprovalTimeRange(value);
    if (value !== "custom") {
      setApprovalTimeRangeStartDate("");
      setApprovalTimeRangeEndDate("");
    }
  };

  const handleApprovalTimeRangeDateChange = (type, value) => {
    if (type === "start") {
      setApprovalTimeRangeStartDate(value);
    } else {
      setApprovalTimeRangeEndDate(value);
    }
  };

  // handle date picker date

  const handleRegistrationDate = (date) => {
    const utcDateString = dateFormatUtc(date);
    searchParam.delete("page");
    searchParam.set("registrationDate", utcDateString);
    setSearchParam(searchParam);
  };

  // approve consultant handler

  const approveConsultantHandler = (id, status) => {
    setApproveStatus(status);
    setStatusId(id);
    setApproveConsultant(true);
  };

  const moveToBinHandler = (id) => {
    setStatusId(id);
    setBinRemark("");
    setBinRemarkError("");
    setMoveToBinModal(true);
  };

  const restoreFromBinHandler = (id) => {
    setStatusId(id);
    setRestoreFromBinModal(true);
  };

  // gender handler

  const genderHandler = (value) => {
    if (genderValue === value) {
      searchParam.delete("gender");
    }  else {
      searchParam.set("gender", value);
    }
    searchParam.delete("page");
    setSearchParam(searchParam);
  };
  // flag handler
  const flagHandler = (value) => {
    if(flagValue === value){
      searchParam.delete("missed")
    }  else {
      searchParam.set("missed", value)
    }
    searchParam.delete("page") ;
    setSearchParam(searchParam)
  }

  const problemHandler = (value) => {
    if (problemValue === value) {
      searchParam.delete("problem");
    } else {
      searchParam.set("problem", value);
    }
    searchParam.delete("page");
    setSearchParam(searchParam);
  };

  const skillHandler = (value) => {
    if (skillsValue === value) {
      searchParam.delete("skills");
    } else {
      searchParam.set("skills", value);
    }
    searchParam.delete("page");
    setSearchParam(searchParam);
  };

  // Tag handler
  const tagHandler = (value) => {
    if (tagValue === value) {
      searchParam.delete("tag");
    } else {
      searchParam.set("tag", value);
    }
    searchParam.delete("page");
    setSearchParam(searchParam);
  };

  // Group filter handler
  const groupFilterHandler = (value) => {
    if (groupValue === value) {
      searchParam.delete("group");
    } else {
      searchParam.set("group", value);
    }
    searchParam.delete("page");
    setSearchParam(searchParam);
  };

  const subGroupFilterHandler = (value) => {
    if (subGroupValue === value) {
      searchParam.delete("subGroup");
    } else {
      searchParam.set("subGroup", value);
    }
    searchParam.delete("page");
    setSearchParam(searchParam);
  };

  // Set group on a consultant row
  const handleGroupChange = async (consultantId, group) => {
    try {
      const { data } = await setConsultantGroupApi({ consultantId, group: group || null });
      if (data.code === 200) {
        setConsultantGroups((prev) => ({ ...prev, [consultantId]: group }));
        toastMessage("Group updated", "success", "groupSet");
      } else {
        toastMessage(data.message || "Failed to update group", "error", "groupSet");
      }
    } catch (error) {
      console.log("error setting group", error);
      toastMessage("Failed to update group", "error", "groupSet");
    }
  };

  const handleSubGroupChange = async (consultantId, subGroup) => {
    try {
      const { data } = await setConsultantSubGroupApi({ consultantId, subGroup: subGroup || null });
      if (data.code === 200) {
        setConsultantSubGroups((prev) => ({ ...prev, [consultantId]: subGroup }));
        toastMessage("Sub group updated", "success", "subGroupSet");
      } else {
        toastMessage(data.message || "Failed to update sub group", "error", "subGroupSet");
      }
    } catch (error) {
      console.log("error setting sub group", error);
      toastMessage("Failed to update sub group", "error", "subGroupSet");
    }
  };



  // Get color for tag based on tag ID
  const getTagColor = (tagId) => {
    if (!tagId) return "#25D366"; // Default color
    
    // Predefined color palette
    const colors = [
      "#25D366", // Green
      "#FF6B6B", // Red
      "#4ECDC4", // Teal
      "#45B7D1", // Blue
      "#FFA07A", // Light Salmon
      "#98D8C8", // Mint
      "#F7DC6F", // Yellow
      "#BB8FCE", // Purple
      "#85C1E2", // Sky Blue
      "#F8B739", // Orange
      "#E74C3C", // Dark Red
      "#3498DB", // Bright Blue
      "#2ECC71", // Emerald
      "#9B59B6", // Amethyst
      "#1ABC9C", // Turquoise
      "#E67E22", // Carrot
      "#34495E", // Dark Blue Grey
      "#16A085", // Green Sea
      "#C0392B", // Dark Red
      "#8E44AD", // Dark Purple
    ];
    
    // Convert tagId to string and create a simple hash
    const idString = String(tagId);
    let hash = 0;
    for (let i = 0; i < idString.length; i++) {
      hash = idString.charCodeAt(i) + ((hash << 5) - hash);
    }
    
    // Get color index from hash
    const colorIndex = Math.abs(hash) % colors.length;
    return colors[colorIndex];
  };

  // Fetch all tags
  const fetchAllTagsHandler = async () => {
    try {
      const { data } = await fetchAllTagsApi();
      if (data.code === 200) {
        // API returns tags as array directly in result, or as result.tags
        const tagsArray = Array.isArray(data?.result) ? data.result : (data?.result?.tags || []);
        setAllTags(tagsArray);
        console.log("Fetched tags:", tagsArray);
        return tagsArray; // Return tags for use in handleCreateTag
      } else {
        setAllTags([]);
        toastMessage(data.message, "error", "tagList");
        return [];
      }
    } catch (error) {
      console.log("error fetching tags", error);
      setAllTags([]);
      return [];
    }
  };

  // Create new tag
  const handleCreateTag = async (tagName, consultantId) => {
    try {
      // Create the tag first
      const { data } = await createTagApi({ name: tagName });
      if (data.code === 200) {
        const newTag = data?.result || { _id: data?.result?._id, name: tagName };
        const tagId = newTag._id || newTag.id;
        
        toastMessage("Tag created successfully", "success", "tagCreate");
        
        // Refresh tags list and wait for it to complete
        const updatedAllTags = await fetchAllTagsHandler();
        
        // If consultantId is provided, automatically add this tag to the consultant
        if (consultantId && tagId) {
          try {
            // Use the updated tags from API response
            const tagsToSearch = updatedAllTags.length > 0 ? updatedAllTags : allTags;
            
            // Get current tags for this consultant
            const currentTags = consultantTags[consultantId] || [];
            
            // Check if tag is already added
            const tagExists = currentTags.some(t => {
              const tId = t._id || t.id;
              return tId === tagId;
            });
            
            if (!tagExists) {
              // Find the full tag object from updated tags
              const fullTag = tagsToSearch.find(t => (t._id || t.id) === tagId) || newTag;
              
              // Add the new tag to consultant
              const updatedTags = [...currentTags, fullTag];
              const tagIds = updatedTags.map(t => {
                const tId = t._id || t.id;
                return tId;
              }).filter(Boolean);
              
              // Send to backend with consultantId
              const requestData = {
                consultantId: consultantId,
                tags: tagIds,
              };
              
              console.log("Auto-adding new tag to consultant:", {
                consultantId: consultantId,
                tagId: tagId,
                tagName: tagName,
                requestData: requestData
              });
              
              const { data: setTagData } = await setConsultantTagsApi(requestData);
              
              if (setTagData.code === 200) {
                // Update state
                setConsultantTags((prev) => {
                  const updated = { ...prev };
                  updated[consultantId] = updatedTags;
                  return updated;
                });
                toastMessage("Tag created and added to consultant", "success", "tagSet");
              } else {
                toastMessage(setTagData.message || "Failed to add tag to consultant", "error", "tagSet");
              }
            }
          } catch (error) {
            console.log("error auto-adding tag to consultant", error);
            toastMessage("Tag created but failed to add to consultant", "warning", "tagSet");
          }
        }
      } else {
        toastMessage(data.message, "error", "tagCreate");
      }
    } catch (error) {
      console.log("error creating tag", error);
      toastMessage("Failed to create tag", "error", "tagCreate");
    }
  };

  // Edit tag
  const handleEditTag = async (tagId, newName) => {
    try {
      const { data } = await updateTagApi({ tagId, name: newName });
      if (data.code === 200) {
        toastMessage("Tag updated successfully", "success", "tagEdit");
        await fetchAllTagsHandler();
        // Refresh consultant list to update tag names
        fetchConsultantListHandler(isNew);
      } else {
        toastMessage(data.message, "error", "tagEdit");
      }
    } catch (error) {
      console.log("error editing tag", error);
      toastMessage("Failed to update tag", "error", "tagEdit");
    }
  };

  // Delete tag
  const handleDeleteTag = async (tagId) => {
    try {
      const { data } = await deleteTagApi(tagId);
      if (data.code === 200) {
        toastMessage("Tag deleted successfully", "success", "tagDelete");
        await fetchAllTagsHandler();
        // Remove deleted tag from all consultants
        setConsultantTags((prev) => {
          const updated = {};
          Object.keys(prev).forEach((consultantId) => {
            updated[consultantId] = (prev[consultantId] || []).filter(
              (tag) => {
                const tId = tag._id || tag.id || tag;
                return tId !== tagId;
              }
            );
          });
          return updated;
        });
        // Clear filter if deleted tag was selected
        if (tagValue === tagId) {
          searchParam.delete("tag");
          setSearchParam(searchParam);
        }
        // Refresh consultant list
        fetchConsultantListHandler(isNew);
      } else {
        toastMessage(data.message, "error", "tagDelete");
      }
    } catch (error) {
      console.log("error deleting tag", error);
      toastMessage("Failed to delete tag", "error", "tagDelete");
    }
  };

  // Handle tag selection for consultant
  const handleTagSelect = async (consultantId, tag) => {
    try {
      // Validate consultantId
      if (!consultantId) {
        toastMessage("Consultant ID is required", "error", "tagSet");
        return;
      }
      
      setTagLoading((prev) => ({ ...prev, [consultantId]: true }));
      
      const currentTags = consultantTags[consultantId] || [];
      const tagId = tag._id || tag.id || tag;
      
      // Validate tagId
      if (!tagId) {
        toastMessage("Tag ID is required", "error", "tagSet");
        setTagLoading((prev) => ({ ...prev, [consultantId]: false }));
        return;
      }
      
      // Check if tag is already selected
      const isSelected = currentTags.some((t) => {
        const tId = t._id || t.id || t;
        return tId === tagId;
      });

      let updatedTags;
      if (isSelected) {
        // Remove tag
        updatedTags = currentTags.filter((t) => {
          const tId = t._id || t.id || t;
          return tId !== tagId;
        });
      } else {
        // Add tag
        updatedTags = [...currentTags, tag];
      }

      // Extract tag IDs as strings/IDs only
      const tagIds = updatedTags.map((t) => {
        const tagId = typeof t === 'object' ? (t._id || t.id) : t;
        return tagId;
      }).filter(Boolean); // Remove any undefined/null values
      
      // Prepare data to send to backend
      const requestData = {
        consultantId: consultantId, // Ensure consultantId is sent
        tags: tagIds, // Array of tag IDs
      };
      
      console.log("Setting tags for consultant:", {
        consultantId: consultantId,
        tagIds: tagIds,
        requestData: requestData
      });
      
      const { data } = await setConsultantTagsApi(requestData);

      if (data.code === 200) {
        // Update consultant tags immediately with full tag objects from allTags
        // IMPORTANT: Preserve tags even if allTags isn't loaded yet
        const fullUpdatedTags = tagIds
          .map((tagId) => {
            // Find the full tag object from allTags
            const fullTag = allTags.find(t => (t._id || t.id) === tagId);
            if (fullTag) {
              return fullTag;
            }
            // If not found, preserve as ID object (will be resolved when allTags loads)
            // This ensures tags don't disappear on refresh
            return { _id: tagId, id: tagId };
          })
          .filter(Boolean); // Remove null/undefined entries
        
        console.log("Tags updated successfully for consultant:", {
          consultantId: consultantId,
          tagCount: fullUpdatedTags.length,
          tags: fullUpdatedTags
        });
        
        // Update ONLY this consultant's tags, don't touch others
        setConsultantTags((prev) => {
          const updated = { ...prev };
          updated[consultantId] = fullUpdatedTags;
          return updated;
        });
        toastMessage("Tag updated successfully", "success", "tagSet");
        // Don't refresh the list immediately - keep the manually set tags in state
        // The tags are already updated in state above, so UI will reflect immediately
        // Only refresh if needed (optional - can be removed if causing issues)
        // fetchConsultantListHandler(isNew);
      } else {
        toastMessage(data.message, "error", "tagSet");
      }
    } catch (error) {
      console.log("error setting tag", error);
      toastMessage("Failed to update tags", "error", "tagSet");
    } finally {
      setTagLoading((prev) => ({ ...prev, [consultantId]: false }));
    }
  };

  // close model

  const closeModel = () => {
    setApproveConsultant(false);
    setStatusModal(false);
    setMoveToBinModal(false);
    setRestoreFromBinModal(false);
    setAddConsultantModel(false);
    setStatusValue("");
    setStatusId("");
    setApproveStatus("");
    setFakeState(null)
    setBinRemark("");
    setBinRemarkError("");
  };

  const confirmMoveToBin = async () => {
    try {
      if (!statusId) return;
      const trimmedRemark = (binRemark || "").trim();
      if (!trimmedRemark) {
        setBinRemarkError("Bin remark is required.");
        return;
      }
      setMoveToBinLoading(true);
      const { data } = await moveConsultantToBinApi({
        consultantId: statusId,
        remark: trimmedRemark,
      });
      if (data?.code === 200) {
        setConsultantList((prev) => prev.filter((consultant) => consultant._id !== statusId));
        setConsultantRequestCount((prev) => (prev > 0 ? prev - 1 : prev));
        toastMessage("Consultant moved to bin successfully", "success", "consultantBin");
        closeModel();
      } else {
        toastMessage(data?.message || "Unable to move consultant to bin", "error", "consultantBin");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setMoveToBinLoading(false);
    }
  };

  const confirmRestoreFromBin = async () => {
    try {
      if (!statusId) return;
      setRestoreFromBinLoading(true);
      const { data } = await restoreConsultantFromBinApi({ consultantId: statusId });
      if (data?.code === 200) {
        setConsultantList((prev) => prev.filter((consultant) => consultant._id !== statusId));
        setConsultantRequestCount((prev) => prev + 1);
        toastMessage("Consultant restored to consultant request successfully", "success", "consultantRestore");
        closeModel();
      } else {
        toastMessage(data?.message || "Unable to restore consultant from bin", "error", "consultantRestore");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setRestoreFromBinLoading(false);
    }
  };

  const setConsultantRequestView = (view) => {
    searchParam.set("isNew", "true");
    searchParam.set("requestView", view);
    searchParam.delete("page");
    searchParam.delete("gender");
    searchParam.delete("missed");
    searchParam.delete("registrationDate");
    setSearchParam(searchParam);
  };

  const setAllConsultantView = () => {
    searchParam.set("isNew", "false");
    searchParam.delete("requestView");
    searchParam.delete("page");
    searchParam.delete("gender");
    searchParam.delete("missed");
    searchParam.delete("registrationDate");
    setSearchParam(searchParam);
  };

  const isNewHandler = (isNew) => {
    const updatedNew = !isNew;
    searchParam.set("isNew", updatedNew);
    searchParam.delete("page");
    searchParam.delete("gender");
    searchParam.delete("missed")
    searchParam.delete("registrationDate");
    searchParam.delete("missed")
    setSearchParam(searchParam);
  };

  // Tab change handler (Consultant Management <-> Consultant Activity)
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    searchParam.delete("page");
    setSearchParam(searchParam);
    setTimeout(() => fetchConsultantListHandler(isNew), 0);
  };

  //------------------listing-Api----------------------------------
  const fetchConsultantListHandler = async (isNew) => {
    try {
      setConsultantList([]);
      showLoader();

      // Deleted consultant list (separate API) - only when Consultant Activity > Deleted Consultant
      if ((activeTab === 1 && activityListType === "delete") || isRecycleBinView) {
        const sendData = {
          page: `${activePage}`,
          limit: `${pageLimit}`,
          ...(debounceValue && { search: debounceValue }),
          ...(isRecycleBinView && { listType: "bin" }),
        };
        const { data } = await getDeletedConsultantListApi(sendData);
        if (data?.code === 200) {
          const list = data?.result?.list || [];
          setConsultantList(list);
          setTotal(data?.result?.total || 0);
        } else {
          setConsultantList([]);
          setTotal(0);
          toastMessage(data?.message || "Failed to load", "error", "consultantList");
        }
        hideLoader();
        return;
      }

      const sendData = {
        page: `${activePage}`,
        limit: `${pageLimit}`,
        filter: {},
      };
      if (isNew) {
        sendData.isNew = "true";
      }
      // Deactivate list: only when Consultant Activity > Deactivate
      if (activeTab === 1 && activityListType === "deactive") {
        sendData.filter.status = false;
      }
      if (registrationDate) {
        sendData.filter.registerDate = registrationDate;
      }
      if (genderValue) {
        sendData.filter.gender = genderValue;
      }
      if(flagValue) {
        sendData.filter.missed = flagValue ;
      }
      if (problemValue) {
        sendData.filter.expertise = problemValue;
      }
      
      // Time range filters
      if (timeRange) {
        sendData.filter.timeRange = timeRange;
      }
      if (timeRangeStartDate) {
        sendData.filter.timeRangeStartDate = timeRangeStartDate;
      }
      if (timeRangeEndDate) {
        sendData.filter.timeRangeEndDate = timeRangeEndDate;
      }
      if (approvalTimeRange) {
        sendData.filter.approvalTimeRange = approvalTimeRange;
      }
      if (approvalTimeRangeStartDate) {
        sendData.filter.approvalTimeRangeStartDate = approvalTimeRangeStartDate;
      }
      if (approvalTimeRangeEndDate) {
        sendData.filter.approvalTimeRangeEndDate = approvalTimeRangeEndDate;
      }
      if (tagValue) {
        sendData.filter.tag = tagValue;
      }
      if (groupValue) {
        sendData.filter.group = groupValue;
      }
      if (subGroupValue) {
        sendData.filter.subGroup = subGroupValue;
      }

      if (debounceValue) {
        sendData.search = debounceValue;
      }
      const { data } = await fetchConsultantListApi(sendData);
      if (data.code === 200) {
        const list = data?.result?.list || [];
        setConsultantList(list);
        setConsultantRequestCount(data?.result?.newConsultantcount);
        setTotal(data?.result?.total || 0);
        
        // Update consultant tags from API response
        // IMPORTANT: Don't overwrite manually set tags - only update from API if no manual tags exist
        setConsultantTags((prev) => {
          const tagsMap = {};
          list.forEach((consultant) => {
            const consultantId = consultant._id;
            
            // Check if we have manually updated tags for this consultant
            const existingManualTags = prev[consultantId];
            
            if (existingManualTags && Array.isArray(existingManualTags) && existingManualTags.length > 0) {
              // Keep manually updated tags - don't overwrite with API
              tagsMap[consultantId] = existingManualTags;
            } else {
              // Only use API tags if no manual tags exist
              tagsMap[consultantId] = [];
              
              if (consultant.tags && Array.isArray(consultant.tags) && consultant.tags.length > 0) {
                // Map API tags to full tag objects
                // IMPORTANT: Preserve tags even if allTags isn't loaded yet
                // Store tag IDs so they can be resolved later when allTags loads
                tagsMap[consultantId] = consultant.tags
                  .map((tag) => {
                    if (typeof tag === 'string') {
                      // Try to find in allTags first
                      const fullTag = allTags.find(t => (t._id || t.id) === tag);
                      if (fullTag) {
                        return fullTag;
                      }
                      // If not found, preserve as ID object (will be resolved later)
                      return { _id: tag, id: tag };
                    }
                    // If tag is already an object
                    if (typeof tag === 'object' && tag !== null) {
                      const hasName = tag.name || tag.title || tag.label;
                      if (hasName) {
                        return tag;
                      }
                      // If object has no name, try to find it in allTags
                      const tagId = tag._id || tag.id;
                      if (tagId) {
                        const fullTag = allTags.find(t => (t._id || t.id) === tagId);
                        if (fullTag) {
                          return fullTag;
                        }
                        // Preserve as ID object if not found
                        return { _id: tagId, id: tagId };
                      }
                      return tag;
                    }
                    return tag;
                  })
                  .filter(Boolean); // Remove null/undefined entries
              }
            }
          });
          
          // Merge: keep manually set tags, add API tags for consultants without manual tags
          return { ...tagsMap, ...prev };
        });

        // Populate group state from API response (don't overwrite manually changed groups)
        setConsultantGroups((prev) => {
          const groupMap = { ...prev };
          list.forEach((c) => {
            if (!(c._id in groupMap)) {
              groupMap[c._id] = c.group || "";
            }
          });
          return groupMap;
        });

        setConsultantSubGroups((prev) => {
          const subGroupMap = { ...prev };
          list.forEach((c) => {
            if (!(c._id in subGroupMap)) {
              subGroupMap[c._id] = c.subGroup || "";
            }
          });
          return subGroupMap;
        });
        // scrollToUp();
      } else {
        setConsultantList([]);
        setTotal(0);
        toastMessage(data.message, "error", "consultantList");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      hideLoader();
    }
  };
  // useEffect(() => {
  //   if (debounceValue) {
  //     searchParam.set('query', debounceValue)
  //   } else {
  //     searchParam.delete('query')
  //   }
  //   if (activePage === 1) {
  //     searchParam.delete('page')
  //   }
  //   setSearchParam(searchParam)
  //   getOrder(activePage, debounceValue)
  // }, [searchParam, debounceValue])

  // useEffect(() => {
  //   if (
  //     (startDateSearch && endDateSearch) ||
  //     (startDateSearch === '' && endDateSearch === '')
  //   ) {
  //     getOrder()
  //   }
  // }, [startDateSearch, endDateSearch])
 


  const fetchConsultantSkillHandler = async () => {
    try {
      const { data } = await fatchCategoryApi();
      if (data.code === 200) {
        const updatedConsultantSkill =
          data?.result?.categoryList &&
          data?.result?.categoryList.length > 0 &&
          data?.result?.categoryList.map(({ id, title }) => ({
            value: id,
            label: title,
          }));

        const updatedSKillList =
          data?.result?.skillList &&
          data?.result?.skillList.length &&
          data?.result?.skillList.map(({ id, title }) => ({
            value: id,
            label: title,
          }));
        setConsultantSkillOption(updatedConsultantSkill);
        setSkillList(updatedSKillList);
      } else {
        setConsultantSkillOption([]);
        setSkillList([]);
        toastMessage(data.message, "error", "categoryList");
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  //*********Logout handler function********* */
  const ConsultantLogoutHandler = (id) => {
    setStatusId(id);
    setLogoutCosultantModel(true);
  };

  // validation

  useEffect(() => {
    if (!isNew) {
      fetchConsultantSkillHandler();
      fetchAllTagsHandler();
    }
  }, [isNew]);

  // Refresh tags when allTags changes to resolve tag IDs to full tag objects
  // This resolves tags that were stored as IDs when allTags wasn't loaded yet
  useEffect(() => {
    if (allTags.length > 0) {
      setConsultantTags((prev) => {
        const updated = { ...prev };
        let hasChanges = false;
        
        // Resolve all stored tags to full tag objects
        Object.keys(updated).forEach((consultantId) => {
          const tags = updated[consultantId];
          if (Array.isArray(tags) && tags.length > 0) {
            const resolvedTags = tags.map((tag) => {
              // If tag already has a name, keep it
              if (typeof tag === 'object' && tag !== null) {
                const hasName = tag.name || tag.title || tag.label;
                if (hasName) {
                  return tag;
                }
                
                // If tag doesn't have name, try to resolve from allTags
                const tagId = tag._id || tag.id;
                if (tagId) {
                  const fullTag = allTags.find(t => (t._id || t.id) === tagId);
                  if (fullTag) {
                    hasChanges = true;
                    return fullTag;
                  }
                }
              }
              
              // If tag is a string ID, resolve it
              if (typeof tag === 'string') {
                const fullTag = allTags.find(t => (t._id || t.id) === tag);
                if (fullTag) {
                  hasChanges = true;
                  return fullTag;
                }
              }
              
              return tag;
            });
            
            if (hasChanges) {
              updated[consultantId] = resolvedTags;
            }
          }
        });
        
        // Also update tags from consultantList if they're not in state yet
        if (consultantList.length > 0) {
          consultantList.forEach((consultant) => {
            if (!updated[consultant._id] && consultant.tags && Array.isArray(consultant.tags) && consultant.tags.length > 0) {
              updated[consultant._id] = consultant.tags
                .map((tag) => {
                  if (typeof tag === 'string') {
                    const fullTag = allTags.find(t => (t._id || t.id) === tag);
                    return fullTag || { _id: tag, id: tag };
                  }
                  if (typeof tag === 'object' && tag !== null) {
                    const hasName = tag.name || tag.title || tag.label;
                    if (hasName) {
                      return tag;
                    }
                    const tagId = tag._id || tag.id;
                    if (tagId) {
                      const fullTag = allTags.find(t => (t._id || t.id) === tagId);
                      return fullTag || { _id: tagId, id: tagId };
                    }
                  }
                  return tag;
                })
                .filter(Boolean);
            }
          });
        }
        
        return updated;
      });
    }
  }, [allTags, consultantList]);

  const searchKey = searchParam.toString();

  // Reset to page 1 only when the search text actually changes — not on every listing fetch.
  useEffect(() => {
    if (prevDebounceValue.current === debounceValue) return;
    prevDebounceValue.current = debounceValue;
    const next = new URLSearchParams(searchParam);
    if (!next.get("page")) return;
    next.delete("page");
    setSearchParam(next);
  }, [debounceValue]);

  useEffect(() => {
    fetchConsultantListHandler(isNew);
  }, [searchKey, debounceValue, activeTab, activityListType]);

  const notFoundMessage = !isNew
    ? "Consultant not found!"
    : "Consultant requests not found!";
  return (
    <>
      <DownloadPasswordModal />
      {loader}
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox">
            <h4 className="Title">Consultant Management</h4>
            <div className="block_user_button">
              <span
                className="user_management_excel"
                onClick={handleExcelDownload}
              >
                {loading ? (
                  <Loader />
                ) : (
                  <div className="csv-image-wrapper">
                    <figure>
                      <img src={csv} alt="csv file download" />
                    </figure>
                  </div>
                )}
              </span>
              {activeTab !== 1 && (
                <>
                  <div className="mx-2">
                    <Link to={`${CONSULTANT_DELETE}`}>
                      <div className="block_user_button">
                        <button>Deleted Consultant</button>
                      </div>
                    </Link>
                  </div>
                  <Link to={`${CONSULTANT_ADD}`}>
                    <div className="block_user_button">
                      <button>
                        <AddIcon />
                        Add Consultant
                      </button>
                    </div>
                  </Link>
                </>
              )}
            </div>
          </div>
          {activeTab !== 1 && (
            <div className="consultant_button_wrapper">
              <div className="banner_button_wrapper">
                <button
                  className={`_button ${!isNew && "banner_active"}`}
                  onClick={setAllConsultantView}
                >
                  All Consultant
                </button>
                <button
                  className={`_button ${isNew && !isRecycleBinView && "banner_active"}`}
                  onClick={() => setConsultantRequestView("request")}
                >
                  {`Consultant Requests (${consultantRequstCount || 0})`}
                </button>
                <button
                  className={`_button ${isRecycleBinView && "banner_active"}`}
                  onClick={() => setConsultantRequestView("bin")}
                >
                  Binned List
                </button>
              </div>
            </div>
          )}

          {/* Tab Navigation - Consultant Management & Consultant Activity (only when All Consultant) */}
          {!isNew && (
            <Box sx={{ width: "100%", marginBottom: "20px" }}>
              <CustomTabs
                value={activeTab}
                onChange={handleTabChange}
                aria-label="consultant management tabs"
              >
                <CustomTab label="Consultant Management" />
                <CustomTab label="Consultant Activity" />
              </CustomTabs>
            </Box>
          )}

          {/* Consultant Activity sub-tabs: All, Deactivate, Deleted Consultant (only inside Consultant Activity tab) */}
          {activeTab === 1 && !isNew && (
            <div className="consultant_button_wrapper" style={{ marginBottom: "16px" }}>
              <div className="banner_button_wrapper">
                <button
                  className={`_button ${activityListType === "all" && "banner_active"}`}
                  onClick={() => {
                    setActivityListType("all");
                    searchParam.delete("page");
                    setSearchParam(searchParam);
                  }}
                >
                  All
                </button>
                <button
                  className={`_button ${activityListType === "deactive" && "banner_active"}`}
                  onClick={() => {
                    setActivityListType("deactive");
                    searchParam.delete("page");
                    setSearchParam(searchParam);
                  }}
                >
                  Deactivate
                </button>
                <button
                  className={`_button ${activityListType === "delete" && "banner_active"}`}
                  onClick={() => {
                    setActivityListType("delete");
                    searchParam.delete("page");
                    setSearchParam(searchParam);
                  }}
                >
                  Deleted Consultant
                </button>
              </div>
            </div>
          )}

          <div className="FilterBox FilterArea">
            <div className="form-group search_lg_size userSearch">
              <input
                type="search"
                className={`form-control ${search && "active"}`}
                placeholder="Search by Name, User Name, ID, Phone"
                value={search || ""}
                onChange={(e) => setSearch(e.target.value)}
                style={{ "--color": "#FF8989" }}
              />
              <span className="user_search_icon">
                <IoSearch />
              </span>
            </div>

            {isNew || (
              <>
                {/* Time Range Filter */}
                <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                  <FormControl fullWidth variant="outlined" size="small">
                    <InputLabel>Time Range</InputLabel>
                    <MuiSelect
                      value={timeRange}
                      onChange={(e) => handleTimeRangeChange(e.target.value)}
                      label="Time Range"
                    >
                      <MenuItem value="">
                        <em>All Time Ranges</em>
                      </MenuItem>
                      {timeRangeOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </MuiSelect>
                  </FormControl>
                </div>

                {/* Go Live Date Filter (approvalActionAt based) */}
                <div className="form-group select_sm_width" style={{ minWidth: '210px', flex: '0 0 auto' }}>
                  <FormControl fullWidth variant="outlined" size="small">
                    <InputLabel>Go Live Time Range</InputLabel>
                    <MuiSelect
                      value={approvalTimeRange}
                      onChange={(e) => handleApprovalTimeRangeChange(e.target.value)}
                      label="Go Live Time Range"
                    >
                      <MenuItem value="">
                        <em>All Time Ranges</em>
                      </MenuItem>
                      {timeRangeOptions.map((option) => (
                        <MenuItem key={`approval-${option.value}`} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </MuiSelect>
                  </FormControl>
                  <Typography variant="caption" sx={{ display: "block", mt: 0.5, color: "text.secondary" }}>
                    This filter works on consultant go-live timing and fetches list by approvalActionAt date.
                  </Typography>
                </div>
                
                {timeRange === 'custom' && (
                  <>
                    <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                      <TextField
                        size="small"
                        type="date"
                        variant="outlined"
                        label="Start Date"
                        value={timeRangeStartDate}
                        onChange={(e) => handleTimeRangeDateChange('start', e.target.value)}
                        InputLabelProps={{ shrink: true }}
                      />
                    </div>
                    <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                      <TextField
                        size="small"
                        type="date"
                        variant="outlined"
                        label="End Date"
                        value={timeRangeEndDate}
                        onChange={(e) => handleTimeRangeDateChange('end', e.target.value)}
                        InputLabelProps={{ shrink: true }}
                      />
                    </div>
                  </>
                )}

                {approvalTimeRange === 'custom' && (
                  <>
                    <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                      <TextField
                        size="small"
                        type="date"
                        variant="outlined"
                        label="Go Live Start Date"
                        value={approvalTimeRangeStartDate}
                        onChange={(e) => handleApprovalTimeRangeDateChange('start', e.target.value)}
                        InputLabelProps={{ shrink: true }}
                      />
                    </div>
                    <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                      <TextField
                        size="small"
                        type="date"
                        variant="outlined"
                        label="Go Live End Date"
                        value={approvalTimeRangeEndDate}
                        onChange={(e) => handleApprovalTimeRangeDateChange('end', e.target.value)}
                        InputLabelProps={{ shrink: true }}
                      />
                    </div>
                  </>
                )}

                {/* Gender Filter */}
                <div className="form-group select_sm_width">
                  <Select
                    className={`form-control ${genderValue && "active"}`}
                    value={genderValue || ""}
                    onChange={(e) => genderHandler(e.target.value)}
                  >
                    <option value="">Gender</option>
                    {gender &&
                      gender.length > 0 &&
                      gender.map((gender) => {
                        return (
                          <option value={gender.value} key={gender.id}>
                            {gender.name}
                          </option>
                        );
                      })}
                  </Select>
                </div>

                {/* Flag Filter */}
                {/* <div className="form-group select_sm_width">
                  <Select
                    className={`form-control ${flagValue && "active"}`}
                    value={flagValue || ""}
                    onChange={(e) => flagHandler(e.target.value)}
                  >
                    <option value="">Flag</option>
                    {flag &&
                      flag.length > 0 &&
                      flag.map((flag) => {
                        return (
                          <option value={flag.value} key={flag.id}>
                            {flag.name}
                          </option>
                        );
                      })}
                  </Select>
                </div> */}

                {/* Problem filter */}
                <div className="form-group select_sm_width">
                  <Select
                    className={`form-control ${problemValue && "active"}`}
                    value={problemValue || ""}
                    onChange={(e) => problemHandler(e.target.value)}
                  >
                    <option value="">Problems</option>
                    {consultantSkillOption &&
                      consultantSkillOption.length > 0 &&
                      consultantSkillOption.map((skill) => {
                        return (
                          <option value={skill.value} key={skill.value}>
                            {charLimit(skill.label, 20)}
                          </option>
                        );
                      })}
                  </Select>
                </div>

                {/* Tag Filter */}
                <div className="form-group select_sm_width">
                  <Button
                    variant="outlined"
                    onClick={(e) => setTagsFilterAnchorEl(e.currentTarget)}
                    className={`form-control ${tagValue && "active"}`}
                    style={{
                      width: "100%",
                      textAlign: "left",
                      justifyContent: "space-between",
                      textTransform: "none",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      padding: "8px 12px",
                      backgroundColor: tagValue ? "#f8f9fa" : "#fff",
                    }}
                  >
                    <span>
                      {tagValue
                        ? allTags.find((t) => (t._id || t.id) === tagValue)?.name ||
                          allTags.find((t) => (t._id || t.id) === tagValue)?.title ||
                          allTags.find((t) => (t._id || t.id) === tagValue)?.label ||
                          "Tags"
                        : "Tags"}
                    </span>
                    <span style={{ marginLeft: "8px" }}>▼</span>
                  </Button>
                  <Menu
                    anchorEl={tagsFilterAnchorEl}
                    open={Boolean(tagsFilterAnchorEl)}
                    onClose={() => setTagsFilterAnchorEl(null)}
                    PaperProps={{
                      style: {
                        maxHeight: 400,
                        width: "250px",
                      },
                    }}
                  >
                    <MenuItem
                      onClick={() => {
                        tagHandler("");
                        setTagsFilterAnchorEl(null);
                      }}
                      selected={!tagValue}
                    >
                      <ListItemText>All Tags</ListItemText>
                    </MenuItem>
                    {allTags &&
                      allTags.length > 0 &&
                      allTags.map((tag) => {
                        const tagId = tag._id || tag.id;
                        const tagName = tag.name || tag.title || tag.label;
                        const tagColor = getTagColor(tagId);
                        return (
                          <MenuItem
                            key={tagId}
                            onClick={(e) => {
                              e.stopPropagation();
                              tagHandler(tagId);
                              setTagsFilterAnchorEl(null);
                            }}
                            selected={tagValue === tagId}
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <div style={{ display: "flex", alignItems: "center", gap: "8px", flex: 1 }}>
                              <div
                                style={{
                                  width: "12px",
                                  height: "12px",
                                  borderRadius: "50%",
                                  backgroundColor: tagColor,
                                  flexShrink: 0,
                                }}
                              />
                              <ListItemText>{tagName}</ListItemText>
                            </div>
                            <MuiIconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                if (window.confirm(`Are you sure you want to delete the tag "${tagName}"?`)) {
                                  handleDeleteTag(tagId);
                                  setTagsFilterAnchorEl(null);
                                }
                              }}
                              sx={{
                                padding: "4px",
                                marginLeft: "8px",
                                "&:hover": { backgroundColor: "rgba(255,0,0,0.1)" },
                              }}
                            >
                              <DeleteIcon fontSize="small" sx={{ color: "error.main" }} />
                            </MuiIconButton>
                          </MenuItem>
                        );
                      })}
                  </Menu>
                </div>

                {/* Group Filter */}
                <div className="form-group select_sm_width">
                  {(() => {
                    const colors = GROUP_COLORS[groupValue] || null;
                    return (
                      <select
                        value={groupValue || ""}
                        onChange={(e) => groupFilterHandler(e.target.value)}
                        style={{
                          width: "100%",
                          fontSize: "13px",
                          padding: "6px 10px",
                          borderRadius: "6px",
                          border: colors ? `2px solid ${colors.bg}` : "1px solid #ced4da",
                          backgroundColor: colors ? colors.bg : "#fff",
                          color: colors ? colors.text : "#555",
                          fontWeight: colors ? "600" : "400",
                          cursor: "pointer",
                          outline: "none",
                        }}
                      >
                        <option value="" style={{ backgroundColor: "#fff", color: "#555" }}>Group</option>
                        <option value="a"    style={{ backgroundColor: GROUP_COLORS["a"].bg,    color: "#fff" }}>a</option>
                        <option value="b"    style={{ backgroundColor: GROUP_COLORS["b"].bg,    color: "#fff" }}>b</option>
                        <option value="c"    style={{ backgroundColor: GROUP_COLORS["c"].bg,    color: "#fff" }}>c</option>
                        <option value="dead" style={{ backgroundColor: GROUP_COLORS["dead"].bg, color: "#fff" }}>dead</option>
                        <option value="new"  style={{ backgroundColor: GROUP_COLORS["new"].bg,  color: "#fff" }}>new</option>
                        <option value="query" style={{ backgroundColor: GROUP_COLORS["query"].bg, color: "#fff" }}>query</option>
                      </select>
                    );
                  })()}
                </div>

                <div className="form-group select_sm_width">
                  {(() => {
                    const colors = SUB_GROUP_COLORS[subGroupValue] || null;
                    return (
                      <select
                        value={subGroupValue || ""}
                        onChange={(e) => subGroupFilterHandler(e.target.value)}
                        style={{
                          width: "100%",
                          fontSize: "13px",
                          padding: "6px 10px",
                          borderRadius: "6px",
                          border: colors ? `2px solid ${colors.bg}` : "1px solid #ced4da",
                          backgroundColor: colors ? colors.bg : "#fff",
                          color: colors ? colors.text : "#555",
                          fontWeight: colors ? "600" : "400",
                          cursor: "pointer",
                          outline: "none",
                        }}
                      >
                        <option value="" style={{ backgroundColor: "#fff", color: "#555" }}>Sub Group</option>
                        {SUB_GROUP_OPTIONS.map((option) => (
                          <option key={option} value={option} style={{ backgroundColor: SUB_GROUP_COLORS[option].bg, color: "#fff" }}>
                            {option}
                          </option>
                        ))}
                      </select>
                    );
                  })()}
                </div>

                {/* Registration Date */}
                {/* <div className="form-group date_picker">
                  <DatePicker
                    className={`form-control ${registrationDate && "active"}`}
                    name="startDate"
                    selected={registrationDate}
                    placeholder="Registration Date"
                    onChange={(date) => handleRegistrationDate(date)}
                    maxDate={Date.now()}
                    isClearable
                  />
                </div> */}

                <div className="form-group refresh_button" style={{ minWidth: '120px', flex: '0 0 auto', display: 'flex', gap: '10px' }}>
                  <SecondaryButton onClick={applyFilter}>
                    Apply
                  </SecondaryButton>
                  <SecondaryButton onClick={refreshHandler}>
                    Clear
                  </SecondaryButton>
                </div>
              </>
            )}
          </div>
          <div className="content-table">
            <table>
              <thead>
                <tr>
                  <th>S. No.</th>
                  <th>Profile</th>
                  <th>ID</th>
                  <th>Name</th>
                  <th>User Name</th>
                  <th>Phone Number</th>
                  <th>Type</th>
                  <th>Gender</th>
                  {(isNew || activeTab === 0 || activeTab === 1) && <th>Registration Date</th>}
                  {(isNew || activeTab === 0 || activeTab === 1) && (
                    <th>{isRecycleBinView ? "Binned Date" : "Status Date"}</th>
                  )}
                  {(isNew || (activeTab === 1 && activityListType === "all")) && <th>Today's Chat/Call</th>}
                  {(isNew || (activeTab === 1 && activityListType === "all")) && <th>Today Missed</th>}
                  {(isNew || (activeTab === 1 && activityListType === "all")) && <th>Today Failed</th>}
                  {(isNew || (activeTab === 1 && activityListType === "all")) && <th>Today Complete</th>}
                  {(isNew || (activeTab === 1 && activityListType === "all")) && <th>Today Revenue</th>}
                  {(isNew || (activeTab === 1 && activityListType === "all")) && <th>Flag Count</th>}
                  {isNew && <th>{isRecycleBinView ? "Bin Remark" : "Request Date"}</th>}
                  <th>Tags</th>
                  <th>Group</th>
                  <th>Sub Group</th>
                  <th className="text-center"> Action </th>
                  <th>Logout from all Device</th>
                </tr>
              </thead>
              <tbody>
                {consultantList.length > 0 ? (
                  consultantList.map((consultant, index) => {
                    return (
                      <React.Fragment key={index}>
                        <tr>
                          <td>{findSerialNumber(index, activePage, pageLimit)}</td>

                          <td className="user_profile_image">
                            <div style={{ position: "relative", display: "inline-block" }}>
                              <img
                                src={consultant.profileImage || profileImage}
                                alt={`${index + 1}-${consultant.name
                                  } profile image`}
                                style={{ width: "50px", height: "50px", borderRadius: "50%", objectFit: "cover" }}
                              />
                              {/* Tags Badge on Profile Image - Show Tag Name */}
                              {(() => {
                                // Get tags ONLY from state (most up-to-date)
                                const consultantTagList = consultantTags[consultant._id];
                                
                                // Check if consultant has tags
                                const hasTags = consultantTagList && 
                                               Array.isArray(consultantTagList) && 
                                               consultantTagList.length > 0;
                                
                                if (hasTags) {
                                  // Map all tags to their names from allTags
                                  // IMPORTANT: Never show IDs, only show tag names
                                  const tagNames = consultantTagList
                                    .map((tag) => {
                                      // If tag is an object with name property
                                      if (typeof tag === "object" && tag !== null) {
                                        const name = tag.name || tag.title || tag.label;
                                        if (name) return name;
                                        
                                        // If object but no name, try to find from allTags using ID
                                        const tagId = tag._id || tag.id;
                                        if (tagId && allTags && allTags.length > 0) {
                                          const fullTag = allTags.find(t => (t._id || t.id) === tagId);
                                          if (fullTag) {
                                            return fullTag.name || fullTag.title || fullTag.label || "";
                                          }
                                        }
                                        return ""; // Return empty if no name found (never show ID)
                                      }
                                      
                                      // If tag is just an ID string, look it up in allTags
                                      if (typeof tag === 'string' && allTags && allTags.length > 0) {
                                        // Make sure it's not already a name (check if it exists as a name in allTags)
                                        const fullTag = allTags.find(t => (t._id || t.id) === tag);
                                        if (fullTag) {
                                          return fullTag.name || fullTag.title || fullTag.label || "";
                                        }
                                        // If not found in allTags, it might be an ID - return empty (never show ID)
                                        return "";
                                      }
                                      
                                      return ""; // Never show IDs
                                    })
                                    .filter(Boolean); // Remove empty strings
                                  
                                  if (tagNames.length === 0) {
                                    return null; // No valid tag names found - don't show anything
                                  }
                                  
                                  // Get first tag name and ID for color
                                  const firstTag = consultantTagList[0];
                                  const firstTagId = typeof firstTag === 'object' && firstTag !== null 
                                    ? (firstTag._id || firstTag.id)
                                    : (typeof firstTag === 'string' ? firstTag : null);
                                  const firstTagName = tagNames[0];
                                  const tagCount = tagNames.length;
                                  const badgeColor = getTagColor(firstTagId);
                                  
                                  // If multiple tags, show first tag name with count indicator
                                  const displayText = tagCount > 1 ? `${firstTagName} (+${tagCount - 1})` : firstTagName;
                                  
                                  return (
                                    <div
                                      style={{
                                        position: "absolute",
                                        top: "-12px",
                                        right: "-25px",
                                        backgroundColor: badgeColor,
                                        color: "#fff",
                                        borderRadius: "4px",
                                        padding: "2px 6px",
                                        fontSize: "10px",
                                        fontWeight: "bold",
                                        border: "2px solid #fff",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                        zIndex: 10,
                                        cursor: "pointer",
                                        maxWidth: "100px",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                      }}
                                      title={tagNames.join(", ") || displayText}
                                    >
                                      {displayText}
                                    </div>
                                  );
                                }
                                return null;
                              })()}
                              {/* badge on Profile Image */}
                              {(() => {
                                const grp = consultantGroups[consultant._id];
                                if (!grp) return null;
                                const colors = GROUP_COLORS[grp] || { bg: "#90A4AE", text: "#fff" };
                                return (
                                  <div
                                    style={{
                                      position: "absolute",
                                      bottom: "-10px",
                                      left: "50%",
                                      transform: "translateX(-50%)",
                                      backgroundColor: colors.bg,
                                      color: colors.text,
                                      borderRadius: "4px",
                                      padding: "1px 5px",
                                      fontSize: "9px",
                                      fontWeight: "bold",
                                      border: "2px solid #fff",
                                      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                      zIndex: 10,
                                      whiteSpace: "nowrap",
                                    }}
                                    title={grp}
                                  >
                                    {grp}
                                  </div>
                                );
                              })()}
                            </div>
                          </td>
                          <td>{consultant.userId || '---'}</td>

                          <td>
                            {consultant.name
                              ? CapitalizeFirstWord(consultant.name)
                              : "---"}
                          </td>
                          <td>
                            {consultant.accountName || consultant.userName || consultant.username || "---"}
                          </td>
                          <td>
                            {consultant.mobile ? (
                              <a href={`tel:${consultant.countryCode || ""}${consultant.mobile}`} style={{ color: '#FF8989', textDecoration: 'none' }}>
                                {`${consultant.countryCode || ""}${consultant.mobile}`}
                              </a>
                            ) : (
                              "---"
                            )}
                          </td>
                          <td>
                            {consultant.consType
                              ? CapitalizeFirstWord(consultant.consType)
                              : "---"}
                          </td>
                          <td>
                            {consultant.gender
                              ? CapitalizeFirstWord(consultant.gender)
                              : "---"}
                          </td>
                          {(isNew || activeTab === 0 || activeTab === 1) && (
                            <td>{dateFormat(consultant.created_at || consultant.createdAt) || "---"}</td>
                          )}
                          {(isNew || activeTab === 0 || activeTab === 1) && (
                            <td>
                              {dateFormat(
                                (isRecycleBinView
                                  ? consultant.binnedAt
                                  : (
                                    consultant.idLiveDate ||
                                    consultant.statusUpdatedAt ||
                                    consultant.approvalActionAt ||
                                    consultant.approvedAt ||
                                    consultant.disapprovedAt ||
                                    consultant.binnedAt
                                  ))
                              ) || "---"}
                            </td>
                          )}
                          {(isNew || (activeTab === 1 && activityListType === "all")) && (
                            <td>{consultant.todaysConsultationsAllStatus ?? "---"}</td>
                          )}
                          {(isNew || (activeTab === 1 && activityListType === "all")) && (
                            <td>{consultant.todaysMissedChatsAndCalls ?? consultant.totalMissedChatsAndCalls ?? "---"}</td>
                          )}
                          {(isNew || (activeTab === 1 && activityListType === "all")) && (
                            <td>{consultant.todaysFailedChatsAndCalls ?? consultant.totalFailedChatsAndCalls ?? "---"}</td>
                          )}
                          {(isNew || (activeTab === 1 && activityListType === "all")) && (
                            <td>{consultant.todaysCompletedChatsAndCalls ?? consultant.todaysConsultationsAllStatus ?? "---"}</td>
                          )}
                          {(isNew || (activeTab === 1 && activityListType === "all")) && (
                            <td>{consultant.todaysEarnings ? Number(consultant.todaysEarnings).toFixed(2) : "---"}</td>
                          )}
                          {(isNew || (activeTab === 1 && activityListType === "all")) && (
                            <td>{consultant.reviewFlagCount ?? "---"}</td>
                          )}
                          {isNew && (
                            <td>
                              {isRecycleBinView
                                ? consultant.binnedRemark || "---"
                                : (consultant.createdAt
                                    ? dateFormat(consultant.createdAt)
                                    : "---")}
                            </td>
                          )}
                          <td>
                            {tagLoading[consultant._id] ? (
                              <Loader />
                            ) : (
                              <div style={{ display: "flex", gap: "8px", alignItems: "center", flexWrap: "wrap" }}>
                                {/* Selected Tags Display */}
                                {(() => {
                                  const selected = consultantTags[consultant._id] || [];
                                  if (selected.length > 0) {
                                    return selected
                                      .map((tag) => {
                                        // Get tag ID
                                        const tagId = typeof tag === 'string' ? tag : (tag._id || tag.id);
                                        
                                        // Try to get name from tag object first
                                        let tagName = "";
                                        if (typeof tag === "object" && tag !== null) {
                                          tagName = tag.name || tag.title || tag.label || "";
                                        }
                                        
                                        // If no name found, look up in allTags
                                        if (!tagName && tagId) {
                                          const fullTag = allTags.find(t => (t._id || t.id) === tagId);
                                          if (fullTag) {
                                            tagName = fullTag.name || fullTag.title || fullTag.label || "";
                                          }
                                        }
                                        
                                        // Only render if we have a valid tag name (never show ID)
                                        if (!tagName) {
                                          return null;
                                        }
                                        
                                        const tagColor = getTagColor(tagId);
                                        return (
                                          <Chip
                                            key={tagId}
                                            label={tagName}
                                            size="small"
                                            onDelete={() => handleTagSelect(consultant._id, tag)}
                                            style={{
                                              backgroundColor: tagColor,
                                              color: "#fff",
                                              fontSize: "12px",
                                            }}
                                          />
                                        );
                                      })
                                      .filter(Boolean); // Remove null entries
                                  }
                                  return null;
                                })()}
                                
                                {/* Tag Select Dropdown */}
                                <div style={{ position: "relative" }}>
                                  <Select
                                    className="form-control"
                                    value={selectedTagValue[consultant._id] || ""}
                                    onChange={(e) => {
                                      const selectedTagId = e.target.value;
                                      
                                      if (selectedTagId && selectedTagId !== "create_new") {
                                        const selectedTag = allTags.find(t => (t._id || t.id) === selectedTagId);
                                        if (selectedTag) {
                                          handleTagSelect(consultant._id, selectedTag);
                                        }
                                        // Reset select
                                        setSelectedTagValue((prev) => ({
                                          ...prev,
                                          [consultant._id]: "",
                                        }));
                                      } else if (selectedTagId === "create_new") {
                                        // Open create tag modal
                                        setCreateTagAnchorEl((prev) => ({
                                          ...prev,
                                          [consultant._id]: e.target,
                                        }));
                                        // Reset select
                                        setSelectedTagValue((prev) => ({
                                          ...prev,
                                          [consultant._id]: "",
                                        }));
                                      }
                                    }}
                                    style={{ minWidth: "150px", fontSize: "12px" }}
                                  >
                                    <option value="">Select Tag</option>
                                    {allTags && allTags.length > 0 && allTags.map((tag) => {
                                      const tagId = tag._id || tag.id;
                                      const tagName = tag.name || tag.title || tag.label || "";
                                      const isSelected = (consultantTags[consultant._id] || []).some(
                                        t => (t._id || t.id) === tagId
                                      );
                                      return (
                                        <option key={tagId} value={tagId} disabled={isSelected}>
                                          {tagName} {isSelected ? "(Selected)" : ""}
                                        </option>
                                      );
                                    })}
                                    <option value="create_new" style={{ fontStyle: "italic" }}>
                                      + Create New Tag
                                    </option>
                                  </Select>
                                </div>
                                
                                {/* Create Tag Popover */}
                                <Popover
                                  open={Boolean(createTagAnchorEl[consultant._id])}
                                  anchorEl={createTagAnchorEl[consultant._id]}
                                  onClose={() => {
                                    setCreateTagAnchorEl((prev) => {
                                      const updated = { ...prev };
                                      delete updated[consultant._id];
                                      return updated;
                                    });
                                    setNewTagName("");
                                  }}
                                  anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "left",
                                  }}
                                >
                                  <Box sx={{ p: 2, minWidth: "250px" }}>
                                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                      Create New Tag
                                    </Typography>
                                    <TextField
                                      fullWidth
                                      size="small"
                                      placeholder="Enter tag name"
                                      value={newTagName}
                                      onChange={(e) => setNewTagName(e.target.value)}
                                      onKeyPress={(e) => {
                                        if (e.key === "Enter") {
                                          handleCreateTag(newTagName.trim(), consultant._id);
                                          setCreateTagAnchorEl((prev) => {
                                            const updated = { ...prev };
                                            delete updated[consultant._id];
                                            return updated;
                                          });
                                          setNewTagName("");
                                        }
                                      }}
                                      sx={{ mb: 1 }}
                                      autoFocus
                                    />
                                    <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
                                      <Button size="small" onClick={() => {
                                        setCreateTagAnchorEl((prev) => {
                                          const updated = { ...prev };
                                          delete updated[consultant._id];
                                          return updated;
                                        });
                                        setNewTagName("");
                                      }}>
                                        Cancel
                                      </Button>
                                      <Button
                                        size="small"
                                        variant="contained"
                                        onClick={() => {
                                          handleCreateTag(newTagName.trim(), consultant._id);
                                          setCreateTagAnchorEl((prev) => {
                                            const updated = { ...prev };
                                            delete updated[consultant._id];
                                            return updated;
                                          });
                                          setNewTagName("");
                                        }}
                                        style={{ backgroundColor: "#25D366" }}
                                      >
                                        Create
                                      </Button>
                                    </Box>
                                  </Box>
                                </Popover>
                              </div>
                            )}
                          </td>
                          <td>
                            {(() => {
                              const grp = consultantGroups[consultant._id] || "";
                              const colors = GROUP_COLORS[grp] || null;
                              return (
                                <select
                                  value={grp}
                                  onChange={(e) => handleGroupChange(consultant._id, e.target.value)}
                                  style={{
                                    minWidth: "120px",
                                    fontSize: "12px",
                                    padding: "4px 8px",
                                    borderRadius: "6px",
                                    border: colors ? `2px solid ${colors.bg}` : "1px solid #ced4da",
                                    backgroundColor: colors ? colors.bg : "#f8f9fa",
                                    color: colors ? colors.text : "#555",
                                    fontWeight: colors ? "600" : "400",
                                    cursor: "pointer",
                                    outline: "none",
                                  }}
                                >
                                  <option value="" style={{ backgroundColor: "#fff", color: "#555" }}>No Group</option>
                                  <option value="a"   style={{ backgroundColor: GROUP_COLORS["a"].bg,    color: "#fff" }}>A</option>
                                  <option value="b"   style={{ backgroundColor: GROUP_COLORS["b"].bg,    color: "#fff" }}>B</option>
                                  <option value="c"   style={{ backgroundColor: GROUP_COLORS["c"].bg,    color: "#fff" }}>C</option>
                                  <option value="dead" style={{ backgroundColor: GROUP_COLORS["dead"].bg, color: "#fff" }}>Dead</option>
                                  <option value="new" style={{ backgroundColor: GROUP_COLORS["new"].bg,  color: "#fff" }}>New</option>
                                  <option value="query" style={{ backgroundColor: GROUP_COLORS["query"].bg, color: "#fff" }}>Query</option>
                                </select>
                              );
                            })()}
                          </td>
                          <td>
                            {(() => {
                              const subGrp = consultantSubGroups[consultant._id] || "";
                              const colors = SUB_GROUP_COLORS[subGrp] || null;
                              return (
                                <select
                                  value={subGrp}
                                  onChange={(e) => handleSubGroupChange(consultant._id, e.target.value)}
                                  style={{
                                    minWidth: "110px",
                                    fontSize: "12px",
                                    padding: "4px 8px",
                                    borderRadius: "6px",
                                    border: colors ? `2px solid ${colors.bg}` : "1px solid #ced4da",
                                    backgroundColor: colors ? colors.bg : "#f8f9fa",
                                    color: colors ? colors.text : "#555",
                                    fontWeight: colors ? "600" : "400",
                                    cursor: "pointer",
                                    outline: "none",
                                  }}
                                >
                                  <option value="" style={{ backgroundColor: "#fff", color: "#555" }}>No Sub Group</option>
                                  {SUB_GROUP_OPTIONS.map((option) => (
                                    <option
                                      key={option}
                                      value={option}
                                      style={{ backgroundColor: SUB_GROUP_COLORS[option].bg, color: "#fff" }}
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>
                              );
                            })()}
                          </td>
                          <td>
                            <div className="action_button">
                              <Link
                                to={`/consultant-management/consultant-detail/${consultant._id}${activeTab === 0 ? "?from=management" : "?from=activity"}`}
                              >
                                <IconButton
                                  aria-label="view"
                                  className="px-2 py-0"
                                >
                                  <VisibilityIcon className="eye_icon" />
                                </IconButton>
                              </Link>
                              {activeTab === 0 && (
                                <IconButton
                                  aria-label="edit"
                                  className="px-2 py-0"
                                  onClick={() =>
                                    navigate(`${CONSULTANT_EDIT}/${consultant._id}`)
                                  }
                                  title="Edit Consultant"
                                >
                                  <EditIcon className="edit_icon" />
                                </IconButton>
                              )}
                              {/* Consultant Request: Approve (make live) and Disapprove buttons */}
                              {isNew && (
                                <>
                                  {consultant.pendingForLive ? (
                                    <span
                                      title="Set Final Status to Live from Onboarding Management"
                                      style={{ color: "#198754", fontSize: "12px", fontWeight: 600, whiteSpace: "nowrap" }}
                                    >
                                      Profile Ready, Pending for Live
                                    </span>
                                  ) : (
                                    <IconButton
                                      aria-label="approve"
                                      className="px-2 py-0"
                                      onClick={() =>
                                        approveConsultantHandler(
                                          consultant._id,
                                          true
                                        )
                                      }
                                      title="Approve / Make Live"
                                    >
                                      <CheckCircleOutlineIcon className="tick_icon" />
                                    </IconButton>
                                  )}
                                  <IconButton
                                    aria-label="disapprove"
                                    className="px-2 py-0"
                                    onClick={() =>
                                      approveConsultantHandler(
                                        consultant._id,
                                        false
                                      )
                                    }
                                    title="Disapprove"
                                  >
                                    <BlockIcon className="tick_icon" />
                                  </IconButton>
                                </>
                              )}

                              {/* </Link> */}

                            {/* Status (Active/Block) toggle - only in Consultant Activity */}
                            {activeTab === 1 && (
                              <div>
                                <Switch
                                  checked={!!consultant.status}
                                  onChange={() =>
                                    statusUpdateHandler(
                                      consultant._id,
                                      consultant.status
                                    )
                                  }
                                  title={consultant.status ? "Active (click to Block)" : "Blocked (click to Unblock)"}
                                />
                                <h6>Status</h6>
                              </div>
                            )}
                            {/* isFake toggle - only in Consultant Activity */}
                            {activeTab === 1 && (
                              <div>
                                <Switch
                                  checked={!!consultant.isFake}
                                  onChange={() =>
                                    fakeUpdateHandler(
                                      consultant._id,
                                      consultant.isFake
                                    )
                                  }
                                />
                                <h6>is fake ?</h6>
                              </div>
                            )}
                            {activeTab === 1 && (
                                <IconButton
                                  aria-label="block"
                                  className="px-2 py-0"
                                  onClick={() =>
                                    statusUpdateHandler(
                                      consultant._id,
                                      consultant.status
                                    )
                                  }
                                  title="Block / Unblock"
                                >
                                  <BlockIcon className="tick_icon" />
                                </IconButton>
                              )}
                            </div>
                          </td>
                          <td>
                            <div className="block_user_button d-flex align-items-center gap-2">
                              <button
                                onClick={() =>
                                  ConsultantLogoutHandler(consultant._id)
                                }
                              // ref={buttonref}
                              >
                                Logout
                              </button>
                              {isNew && !isRecycleBinView && (
                                <button
                                  onClick={() => moveToBinHandler(consultant._id)}
                                  title="Move to Bin"
                                >
                                  Bin
                                </button>
                              )}
                              {isRecycleBinView && (
                                <button
                                  onClick={() => restoreFromBinHandler(consultant._id)}
                                  title="Restore to Consultant Request"
                                >
                                  Restore
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      </React.Fragment>
                    );
                  })
                ) : (
                  <NotFound
                    cols={isNew ? 11 : 14}
                    msg={notFoundMessage}
                    icon={NOT_FOUND}
                    loader={loader}
                  />
                )}
              </tbody>
            </table>
          </div>
          <div className="pagination-wrapper mt-4 d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-3">
              <Typography variant="body2" color="textSecondary">
                Show:
              </Typography>
              <select
                value={pageLimit}
                onChange={(e) => handlePageLimitChange(e)}
                style={{ 
                  padding: '8px 12px', 
                  border: '1px solid #ccc', 
                  borderRadius: '4px',
                  fontSize: '14px',
                  minWidth: '80px'
                }}
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
              <Typography variant="body2" color="textSecondary">
                per page
              </Typography>
            </div>
            
            <div className="d-flex align-items-center gap-2">
              <Typography variant="body2" color="textSecondary">
                Showing {((activePage - 1) * pageLimit) + 1} to {Math.min(activePage * pageLimit, total)} of {total} items
              </Typography>
            </div>
            
            {total > pageLimit ? (
              <div className="pagination-wrapper">
                <div className="Pagination">
                  <Pagination
                    activePage={activePage}
                    previousLabel={"previous"}
                    nextLabel={"next"}
                    itemsCountPerPage={pageLimit}
                    totalItemsCount={total}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    hideDisabled={true}
                  />
                </div>
              </div>
            ) : null}
          </div>
        </div>
        {approveConsultant && (
          <ApprovedConsultant
            show={approveConsultant}
            close={closeModel}
            setListing={setConsultantList}
            id={statusId}
            setConsultantCount={setConsultantRequestCount}
            approveStatus={approveStatus}
          />
        )}
        {statusModal && (
          <ConsultantStatus
            show={statusModal}
            close={closeModel}
            setListing={setConsultantList}
            status={statusValue}
            id={statusId}
          />
        )}
        {fakeState && (
          <FakeStatusModal
            show={fakeState}
            close={closeModel}
            setListing={setConsultantList}
            status={fakeState?.status}
            id={fakeState?.id}
          />
        )}
        {addConsultantModel && (
          <AddConsultant
            show={addConsultantModel}
            close={closeModel}
            consultantListApi={() => fetchConsultantListHandler(isNew)}
          />
        )}
        {logoutCosultantModel && (
          <ModalBox
            status={logoutCosultantModel}
            onClose={logoutCloseModel}
            title="Logout Consultant from all Device"
            description="Do you want to logout the consultant from all the devices?"
            action={handleLogoutHandler}
            ref={buttonref}
          />
        )}
        {moveToBinModal && (
          <ModalBox
            status={moveToBinModal}
            onClose={closeModel}
            title="Move consultant to bin"
            description="Do you want to move this consultant to bin? This is a soft delete. Please add a remark before moving."
            action={confirmMoveToBin}
            customizedFooter={
              <button
                onClick={confirmMoveToBin}
                className="custom_button mx-2"
                disabled={moveToBinLoading}
              >
                {moveToBinLoading ? "Moving..." : "Move to Bin"}
              </button>
            }
          >
            <TextField
              fullWidth
              size="small"
              multiline
              minRows={3}
              label="Bin Remark *"
              value={binRemark}
              onChange={(e) => {
                setBinRemark(e.target.value);
                if (binRemarkError) setBinRemarkError("");
              }}
              error={Boolean(binRemarkError)}
              helperText={binRemarkError || "Mention reason for moving consultant to bin."}
            />
          </ModalBox>
        )}
        {restoreFromBinModal && (
          <ModalBox
            status={restoreFromBinModal}
            onClose={closeModel}
            title="Restore consultant from bin"
            description="Do you want to restore this consultant to Consultant Requests?"
            action={confirmRestoreFromBin}
          />
        )}
      </div>
    </>
  );
};

export default ConsultantList;
